import { render, staticRenderFns } from "./Size.vue?vue&type=template&id=c3781a90&scoped=true&"
import script from "./Size.vue?vue&type=script&lang=js&"
export * from "./Size.vue?vue&type=script&lang=js&"
import style0 from "../assets/less/filters.less?vue&type=style&index=0&id=c3781a90&lang=less&scoped=true&"
import style1 from "./Size.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3781a90",
  null
  
)

export default component.exports